import { render, staticRenderFns } from "./ApplicationDetails.vue?vue&type=template&id=5622c792&scoped=true"
import script from "./ApplicationDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationDetails.vue?vue&type=script&lang=js"
import style0 from "./ApplicationDetails.vue?vue&type=style&index=0&id=5622c792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622c792",
  null
  
)

export default component.exports